import { cn } from '@/utils/cn';
import { LucideIcon } from 'lucide-react';
import React from 'react';
interface BannerProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  icon?: LucideIcon;
  iconClassName?: string;
  variant?: 'success' | 'warning' | 'error';
  className?: string;
}

const Banner = ({ title, description, className, icon, variant, iconClassName }: BannerProps) => {
  if (!title) {
    return null;
  }

  const Icon = icon ? icon : null;

  return (
    <div
      className={cn(
        'flex items-center gap-[12px] p-[4px] rounded-[4px]',
        variant === 'success' && 'bg-[#E6F9E9]',
        variant === 'warning' && 'bg-[#FFF3A1]',
        variant === 'error' && 'bg-[#FFE6E6]',
        className
      )}
    >
      {Icon ? (
        <Icon
          className={cn(
            'w-[24px] h-[24px] shrink-0',
            variant === 'success' && 'text-[#008000]',
            variant === 'warning' && 'text-[#EAA300]',
            variant === 'error' && 'text-[#FF0000]',
            iconClassName
          )}
        />
      ) : null}
      <div className="space-y-px">
        <h2
          className={cn(
            'text-[14px] font-normal leading-[20px] text-[#25151E]',
            variant === 'success' && 'text-[#008000]',
            variant === 'warning' && 'text-[#EAA300]',
            variant === 'error' && 'text-[#FF0000]'
          )}
        >
          {title}
        </h2>
        {description ? <p className="text-[12px] font-normal leading-[20px] text-[#666666]">{description}</p> : null}
      </div>
    </div>
  );
};

export default Banner;
